import type { UserRole } from '@/constants/roles';

/**
 * Профиль пользователя в payload ajax после arrayChangeKeyCaseRecursive (ключи в нижнем регистре).
 * Собирается в `Hs\Ajax\User::buildAuthorizedUserPayload` (бэкенд), ключи — lowercase после gateway.
 */
export interface AjaxUserProfile {
    id: number;
    login: string;
    name: string;
    last_name: string;
    email: string;
}

/**
 * Успешная сессия: логин или getCurrentUser.
 * В store попадает целиком ответ API (включая опциональные поля).
 */
export interface UserSessionAuthenticated {
    auth: true;
    success?: boolean;
    user: AjaxUserProfile;
    /** ID групп Bitrix; совпадают с числовыми значениями {@link UserRole} */
    groups: number[];
    id: number;
    /** Сессионный hash; может отсутствовать в старых ответах */
    hash?: string;
    /** Устаревший флаг с бэка; может отсутствовать */
    is_manager?: boolean;
    /**
     * Настройки UI, если бэк их отдаёт (в текущем PHP не обязательны;
     * на фронте используется {@link UserSessionAuthenticated.settings.catalog_per_page}).
     */
    settings?: {
        catalog_per_page?: number;
        [key: string]: unknown;
    };
}

/**
 * Отказ авторизации (логин, getCurrentUser при невалидной сессии).
 */
export interface UserSessionApiDenied {
    success: false;
    auth: false;
    error?: string;
}

/** Ответ refreshCurrentUser / userAuthorize до разборки по веткам */
export type UserSessionApiPayload = UserSessionAuthenticated | UserSessionApiDenied;

/** То, что хранится в `user` модуле Vuex */
export type UserSessionInStore = UserSessionAuthenticated | UserSessionApiDenied | null;

export interface UserState {
    data: UserSessionInStore;
}

export function isUserSessionAuthenticated(data: unknown): data is UserSessionAuthenticated {
    if (data === null || typeof data !== 'object') {
        return false;
    }
    const o = data as Record<string, unknown>;
    return o.auth === true;
}

export function isUserSessionApiDenied(data: unknown): data is UserSessionApiDenied {
    if (data === null || typeof data !== 'object') {
        return false;
    }
    const o = data as Record<string, unknown>;
    return o.success === false && o.auth === false;
}
